import { assembleCompanyView } from "@/company/data/assemble-company-view";
import type { CompanyViewModel } from "@/company/core/types";
import type { DepartmentDefinition } from "@/grid/core/types";
import { DISPLAY_REFRESH_MS, fetchDisplayRawData } from "@/grid/hooks/useDisplayGridData";
import { useQuery } from "@tanstack/react-query";

/** Token-gated Company Sales data for TV kiosks (no Supabase session). */
export function useDisplayCompanyData(department: DepartmentDefinition, token: string | null) {
  return useQuery<CompanyViewModel, Error>({
    queryKey: ["display-company", department.id, token],
    queryFn: async () => {
      const { raw, asOf } = await fetchDisplayRawData(department.id, token!, "company");
      return assembleCompanyView(department, raw, asOf);
    },
    enabled: Boolean(token),
    staleTime: DISPLAY_REFRESH_MS,
    refetchInterval: DISPLAY_REFRESH_MS,
  });
}
